import { CloudStorage } from 'react-native-cloud-storage';
import fs from 'react-native-fs';

import { showNotification } from '../../../../common';
import { storage } from '../../../../services/localstorage';
import { toLog } from '../Backup';
import { getProfileInfo } from '../common/backupData';
import { icloudFileListShort } from './icloud';
import {
    compareFileName,
    extractFilenameFromCloudFileName,
    getFileList,
    ICLOUD_SCOPE,
    isAttachFile
} from './iCloudFiles';

export const ICLOUD_RESTORE_ATTACHES_KEY = 'iCloudRestoreAttaches';
export const ICLOUD_WAIT_SYNC_KEY = 'iCloudWaitSync';

export const doRestoreAttach = async ({ list } = {}) => {
    return list;
};

export const makeRestoreAttachList = async ({ profileId } = {}) => {
    const fileNames = (await getFileList()) ?? [];
    const profileFiles = fileNames?.filter?.(fileName => isAttachFile(fileName, profileId, false)) ?? [];
    const downloadedFiles = fileNames?.filter?.(fileName => isAttachFile(fileName, profileId, true)) ?? [];
    const iCloudFiles = profileFiles?.filter?.(fileName1 => !downloadedFiles.find(fileName2 => compareFileName({
        fileName1,
        fileName2,
    }))) ?? [];
    toLog('ICloud:makeRestoreAttachList', {
        profileId,
        fileNames,
        profileFiles,
        downloadedFiles,
        iCloudFiles,
    });
    return {
        fileNames,
        profileFiles,
        downloadedFiles,
        iCloudFiles,
    };
};

// export const checkSynced = async () => {
//     const files = await makeRestoreAttachList();
//     const { iCloudFiles } = files;
//     if (!iCloudFiles || iCloudFiles.length === 0) {
//         toLog('ICloud:checkSynced:done', files);
//         return true;
//     }
//     setTimeout(() => {
//         toLog('ICloud:checkSynced:waiting', files);
//         checkSynced();
//     }, 1000);
// };

export const startICloudRestoreAttaches = async ({ profileId } = {}) => {
    if (!profileId) {
        throw new Error(Object.R('errors.noProfileIdForBackup'));
    }

    toLog('ICloud:startRestoreAttaches', profileId);

    const files = await makeRestoreAttachList({ profileId });
    const {
        fileNames,
        profileFiles,
        downloadedFiles,
        iCloudFiles,
    } = files;

    if (!fileNames || fileNames.length === 0) {
        toLog('ICloud:startRestoreAttaches:noFiles', files);
        await storage.set(ICLOUD_RESTORE_ATTACHES_KEY, {
            started: false,
            profileId,
            fileNames: [],
        });
        return [];
    }
    toLog('ICloud:startRestoreAttaches:filesFound', icloudFileListShort(iCloudFiles));
    iCloudFiles?.forEach?.(item => {
        CloudStorage.downloadFile(`${item}`, ICLOUD_SCOPE);
        // CloudStorage.triggerSync(`/${item}`, ICLOUD_SCOPE);
    });
    await storage.setForProfile(ICLOUD_WAIT_SYNC_KEY, true);
    // checkSynced();
    console.log('iCloud files to restore:', {
        iCloudFiles,
        profileFiles,
        downloadedFiles,
    });

};

export const checkICloudAttachesSynced = async ({ profileId: profile } = {}) => {
    const { profileId: p } = getProfileInfo();
    const isWaiting = await storage.getForProfile(ICLOUD_WAIT_SYNC_KEY, false);
    const profileId = profile || p;
    const result = {
        done: false,
        profileId,
        rest: 0,
        error: null,
        needAction: false,
        isWaiting,
        files: [],
    };
    if (!isWaiting) {
        result.done = true;
        return result;
    }
    if (!profileId) {
        result.error = Object.R('errors.noProfile');
        return result;
    }
    const files = await makeRestoreAttachList({ profileId });
    const {
        iCloudFiles,
        downloadedFiles,
    } = files;
    if (!iCloudFiles || iCloudFiles.length === 0) {
        result.done = true;
        toLog('ICloud:checkSynced:done - all fetched', icloudFileListShort(files));
        return result;
    }
    if (iCloudFiles && iCloudFiles.length > 0) {
        result.rest = iCloudFiles.length;
        result.files = downloadedFiles;
    }
    return result;
};

export const finishICloudRestoreAttaches = async ({ profileId } = {}) => {
    try {
        const res = await checkICloudAttachesSynced({ profileId });
        if (res?.done && res?.files?.length) {
            await storage.setForProfile(ICLOUD_WAIT_SYNC_KEY, false);
            for (const fileName of res.files) {
                const content = await CloudStorage.readFile(fileName, ICLOUD_SCOPE);
                toLog('ICloud:finishRestoreAttaches:writing', fileName);
                await fs.writeFile(`${fs.DocumentDirectoryPath}/${extractFilenameFromCloudFileName(fileName)}`, content, { encoding: 'base64' });
            }
            showNotification(Object.R('notifications.attachmentsRestored'), false);
        }
    } catch (e) {
        toLog('ICloud:finishRestoreAttaches error (iCloud unavailable)', e?.message ?? e);
    }
};
